import { FilterIcon } from 'assets/icons/FilterIcon';
import { createPortal } from 'react-dom';

import './styles.scss';
import { useEffect, useState } from 'react';
import { CloseIcon } from 'assets/icons/CloseIcon';

export const SideDrawer = ({ children }) => {
  const [open, setOpen] = useState(false);

  const onOpenChange = (value) => {
    setOpen(value);
  };

  useEffect(() => {
    const handleCloseEvent = () => onOpenChange(false);
    window.addEventListener('close-side-drawer', handleCloseEvent);
    return () => window.removeEventListener('close-side-drawer', handleCloseEvent);
  }, []);
  return (
    <>
      <button
        className="side-drawer-trigger"
        onClick={() => onOpenChange(true)}
      >
        <FilterIcon />
      </button>
      {createPortal(
        <div className={`side-drawer ${open ? 'open' : ''}`}>
          <div className="side-drawer-close">
            <button onClick={() => onOpenChange(false)}>
              <CloseIcon />
            </button>
          </div>
          <div className="side-drawer-content">{children}</div>
        </div>,
        document.body
      )}
    </>
  );
};
